import { Session } from "@app/shared/types";
import { getFormattedDateFromString } from "@app/shared/utils";
import { CircularProgress, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import useLocalStorage from "@rehooks/local-storage";
import { scrollToElement } from "components/scrollToElement";
import { useCurrentServerTime } from "hooks/useCurrentServerTime";
import { useUserTimezone } from "hooks/useUserTimezone";
import { DateTime } from "luxon";
import { useEffect } from "react";
import CommunityEventCard from "../community/CommunityEventCard";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        marginBottom: theme.spacing(10),
    },
}));

export const MyInterestGroups = ({
    myInterestGroupSessions,
    loading,
}: {
    myInterestGroupSessions: Session[] | undefined;
    loading: boolean;
}): JSX.Element => {
    const classes = useStyles();

    const [scrollToNewMindfulGroup, setScrollToNewMindfulGroup] = useLocalStorage<
        string | undefined
    >("SCROLL_TO_NEW_INTEREST_GROUP");

    const timezone = useUserTimezone();

    // Rerender with a refreshed time synced to the server every 15 seconds
    const currentServerTime = useCurrentServerTime(15000);

    useEffect(() => {
        if (scrollToNewMindfulGroup && myInterestGroupSessions) {
            const element = document.getElementById("myInterestGroups");
            if (element) {
                scrollToElement(element, { offset: 10 });
                setScrollToNewMindfulGroup(null);
            }
        }
    }, [scrollToNewMindfulGroup, myInterestGroupSessions]);

    if (loading) {
        return <CircularProgress />;
    }

    if (!myInterestGroupSessions || !myInterestGroupSessions.length) {
        return <div id="myInterestGroups"></div>;
    }
    return (
        <div data-testid="myInterestGroups" id="myInterestGroups" className={classes.wrapper}>
            <Typography variant="h2">My Groups </Typography>
            {myInterestGroupSessions.map((session) => (
                <CommunityEventCard
                    key={session.id}
                    event={session}
                    timezone={timezone}
                    currentServerTime={currentServerTime}
                    additionalInfo={`Next session on ${getFormattedDateFromString(
                        session.time,
                        timezone,
                        DateTime.DATE_SHORT,
                    )}`}
                    showLeaveGroupOptions
                />
            ))}
        </div>
    );
};
